export const GET_RECYCLE_BIN = 'GET_RECYCLE_BIN';
export const ADD_RECYCLE_LIST = 'ADD_RECYCLE_LIST';
export const RECYCLE_ALL = 'RECYCLE_ALL';
export const RECYCLE_LIST_ACTION = 'RECYCLE_LIST_ACTION';
export const RECYCLE_BIN_ACTION = 'RECYCLE_BIN_ACTION';
export const RECYCLE_BIN_LOADER = 'RECYCLE_BIN_LOADER';
